(function(EF) {
  var RenderedContentPage = EF.Models.ContentPage.extend({
    initialize: function(attrs, page) {
      if(page) {
        this.page = page;
        this.key = page.get('key');
        this.moduleKey = page.get('moduleKey');
        this.activityKey = page.get('activityKey');
      } else if(attrs.moduleKey) {
        this.page = EF.modules.getModuleByKey(attrs.moduleKey).activities.getActivityByKey(attrs.activityKey).pages.getPageByKey(attrs.pageKey);
      }
    },
    init: function(callback) {
//      if (this.cssPath()){
//        EF.stage.append('<link rel="stylesheet" href="' + this.cssPath() + '" type="text/css" />');
//      }
//      this.loadContent(callback);
//      var forward_button = EF.toolbar.find('[data-forward]');
//      forward_button.prop('disabled', true);
//      forward_button.popover('hide');
    },
    loadContent: function(callback) {
      this.content = this.page.get('content')[EF.language];
      var template = this.template(this.content);
      //this.stage.append(HandlebarsExtensions.finish_blocks(template));
//      bsCompatibility.execute($);
//
//      if (this.page.get('completeOnVisit')){
//        this.completeBackground();
//      }

      if(callback)
        callback();
    },
    loadContent_old: function(callback) {
      var self = this;
      $.get(this.templatePath())
        .success(function(data, status, xhr) {
          self.stage.append(data);
          EF.services.audio_player.clear();

          if(callback)
            callback();
        });
    },
    readyToGo: function() {
      var forward_button = EF.toolbar.find('[data-forward]');
      forward_button.prop('disabled', false);
      forward_button.popover('show');
    },
    forward: function() {
      EF.currentPage.trigger('complete');
    },
    back: function() {
      var prevPage = EF.module.currentActivity.pages.back(EF.currentPage.page);
      if(prevPage) {
        EF.router.navigate(this.page.get('moduleKey') + '/'+ this.page.get('activityKey') + '/' + prevPage.get('key'), { trigger: true });
      }
    },
    templatePath: function() {
      return EF.services.assets.pageTemplateFile(this.key);
    },
    cssPath: function() {
      var cssFileName = null;
      if(EF.module.currentActivity.get('has_common_css')) {
        cssFileName = this.get('activityKey');
      } else if(this.page.get('has_own_css')) {
        cssFileName = this.key;
      }
      return cssFileName ? EF.services.assets.pageCssFile(cssFileName) : null;
    },
    completeBackground: function() {
      this.completed = true;
      this.set('completed', true);
      EF.module.saveProgress(this);
    }
  });

  _.extend(EF.Models, {
    RenderedContentPage: RenderedContentPage
  });

})(window.EF);